/* eslint-disable no-shadow */
export enum SkuImageType {
	catalogPhoto = 'catalogPhoto',
}
